import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRevenueGoalByTractorReport extends Layout {
    excludabletextboxDispatcher: ExcludableTextbox;
    excludabletextboxFleet: ExcludableTextbox;
    excludabletextboxTractor: ExcludableTextbox;
    excludabletextboxTrailer: ExcludableTextbox;
    sourceRevenueGoalByTractor: DataSource;
    switchDriverPourcentage: Switch;
    switchOtherCharges: Switch;
    switchPrintTractor: Switch;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxGroupBy: Textbox;
}
